import { createSelector } from "reselect"
import { mapValues, map } from "lodash"
import { computeDriftValues } from "helpers/drift"
import { getDisplayType } from "./items"
import { getRisk } from "./risk"

const getDriftValues = createSelector(
  [getRisk],
  (risk) => {
    const values = {
      categories: {},
      summary: {},
      factors: {},
    }

    risk.forEach(({ factors, categories, total, specific, factorsTotal }) => {
      map(factors, (value, factor) => {
        if (values.factors[factor]) {
          values.factors[factor].push(value)
        } else {
          values.factors[factor] = [value]
        }
      })

      map(categories, (value, category) => {
        if (values.categories[category]) {
          values.categories[category].push(value)
        } else {
          values.categories[category] = [value]
        }
      })

      if (values.summary.total) {
        values.summary.total.push(total)
      } else {
        values.summary.total = [total]
      }

      if (values.summary.specific) {
        values.summary.specific.push(specific)
      } else {
        values.summary.specific = [specific]
      }

      if (values.summary.factorsTotal) {
        values.summary.factorsTotal.push(factorsTotal)
      } else {
        values.summary.factorsTotal = [factorsTotal]
      }
    })
    return values
  },
)

export const getDrift = createSelector(
  [getDriftValues, getDisplayType],
  (driftValues, displayType) => {
    switch (displayType) {
      case "factors":
        return {
          factor_total: computeDriftValues(driftValues.summary.factorsTotal),
          ...mapValues(driftValues.categories, computeDriftValues),
        }
      case "total":
        return {
          total: computeDriftValues(driftValues.summary.total),
          factor: computeDriftValues(driftValues.summary.factorsTotal),
          specific: computeDriftValues(driftValues.summary.specific),
        }
      default:
        return {
          [`${displayType}_total`]: computeDriftValues(driftValues.categories[displayType]),
          ...mapValues(driftValues.factors, computeDriftValues),
        }
    }
  },
)
